export default __webpack_public_path__ + "static/media/reports.2d7acac9.svg";